<template>
  <div v-show="!loading">
    <NewCheckoutOrder v-if="newCalculationOpenSwitch" />
    <OldCheckoutOrder v-else />
  </div>
</template>

<script>
import { checkLeasePlanCalculateOpen } from '@/api/domain/others'
import OldCheckoutOrder from './old.vue'
import NewCheckoutOrder from './new.vue'

const LOADING_CONFIG = {
  lock: true,
  text: 'Loading',
  spinner: 'QS-icon-loading',
  background: 'rgba(255, 255, 255, 0.7)',
}

export default {
  components: {
    OldCheckoutOrder,
    NewCheckoutOrder,
  },
  props: ['orderId'],
  data() {
    return {
      newCalculationOpenSwitch: false,
      loading: true,
    }
  },
  methods: {
    getNewCalculationOpenSwitch() {
      const loading = this.$loading(LOADING_CONFIG)

      checkLeasePlanCalculateOpen({
        orderId: this.orderId,
      }).then((res) => {
        const { code, data } = res

        if (code === 1) {
          this.newCalculationOpenSwitch = data
        }
      }).finally(() => {
        this.loading = false
        setTimeout(() => {
          loading.close()
        }, 300)
      })
    },
  },
  created() {
    this.getNewCalculationOpenSwitch()
  },
}
</script>

<style lang="scss" scoped>

</style>
